import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRotateCounterClockwise: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-rotate-counter-clockwise, rotate-left"><path d="M5.47978 7.00891C7.30071 4.95438 9.18362 3.75 12.0008 3.75C16.5571 3.75 20.2508 7.44365 20.2508 12C20.2508 16.5563 16.5571 20.25 12.0008 20.25C8.40867 20.25 5.35277 17.9543 4.22021 14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.72998 4V8H8.72998" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowRotateCounterClockwise;
